var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from 'react';
import './style/index.scss';
import FormGroup from '@payscale/design/lib/form-group';
import TextArea from '@payscale/design/lib/textarea';
import Select from '@payscale/design/lib/select';
import { PriorityLevel } from './types/Enum';
import { priorityLevelOptions, supportedtFileExtensions } from './types/Constants';
import Alert from '@payscale/design/lib/alert';
import { PriorityLevelMessages } from './types/Enum';
import { ArticleSearch } from '../ArticleSearch';
export class ContactUsFormContent extends React.Component {
    constructor(props) {
        super(props);
        this.handleClickCancel = this.handleClickCancel.bind(this);
        this.handleClickSubmit = this.handleClickSubmit.bind(this);
        this.handleSaveAttachment = this.handleSaveAttachment.bind(this);
        this.handleSetSubject = this.handleSetSubject.bind(this);
        this.handleSetDescription = this.handleSetDescription.bind(this);
        this.handlePriorityLevelChange = this.handlePriorityLevelChange.bind(this);
        this.renderEachAttachment = this.renderEachAttachment.bind(this);
        this.handleRemoveAttachment = this.handleRemoveAttachment.bind(this);
        this.handleErrorBannerClose = this.handleErrorBannerClose.bind(this);
        this.state = {
            productName: this.props.productName,
            description: '',
            subject: '',
            priority: PriorityLevel.Minor,
            pageSource: this.props.pageSource,
            attachments: [],
            isfileUploadError: false,
            isSubmissionError: false,
            fileUploadErrorMessage: '',
            fileSizeLimitInBytes: 25000000,
            isSubmissionSuccess: null,
            sourceUrl: window.location.href,
            isSending: false
        };
    }
    render() {
        const caseDeflectionClassName = this.props.showCaseDeflection ?
            'contact-us-form__content-wrapper--case-deflection' : '';
        return (React.createElement("div", { className: "contact-us-form__content" },
            this.renderHeader(),
            React.createElement("div", { className: `contact-us-form__content-wrapper ${caseDeflectionClassName}` },
                React.createElement("div", { className: "contact-us-form__layout" },
                    this.renderErrorMessage(),
                    this.renderSubject(),
                    this.renderDescription(),
                    this.renderPrioritySection(),
                    this.renderAttachmentSection(),
                    this.renderButtons()),
                this.props.showCaseDeflection && this.renderArticleSearch())));
    }
    renderArticleSearch() {
        const { articles, initialSearchTerms, isVisible, searchTermCallBack, goToArticle } = this.props;
        return (React.createElement("div", { className: "article-search-container" },
            React.createElement("h3", { className: "article-search-container__header" }, "Find your answer quickly"),
            React.createElement(ArticleSearch, { articles: articles, initialSearchTerms: initialSearchTerms || '', isVisible: isVisible, searchTermCallBack: searchTermCallBack, goToArticle: goToArticle })));
    }
    renderHeader() {
        return (React.createElement("div", { className: "contact-us-form__header" },
            React.createElement("h1", null, "Contact Us"),
            React.createElement("h2", null, "We're here to help!")));
    }
    renderSubject() {
        return (React.createElement("div", { className: "contact-us-form__subject" },
            React.createElement("h3", { className: "contact-us-form__subject-header" }, "Create a Support Ticket"),
            React.createElement("label", { className: "contact-us-form__label contact-us-form__label--required" }, "Subject"),
            React.createElement("input", { className: "contact-us-form__subject-input pxl-form-control", value: this.state.subject, onChange: this.handleSetSubject, disabled: this.state.isSending })));
    }
    renderDescription() {
        return (React.createElement("div", { className: "contact-us-form__description" },
            React.createElement("label", { className: "contact-us-form__label contact-us-form__label--required" }, "Description"),
            React.createElement(FormGroup, null,
                React.createElement(TextArea, { id: "contact-us-form-description", value: this.state.description, onChange: this.handleSetDescription, rows: 10, placeholder: "", disabled: this.state.isSending }))));
    }
    renderPrioritySection() {
        return (React.createElement("div", { className: "contact-us-form__priority-wrapper" },
            React.createElement("label", { className: "contact-us-form__label" }, "Priority Level"),
            React.createElement("div", { className: "contact-us-form__priority-content" },
                this.renderPriorityDropDown(),
                this.renderPriorityMessage())));
    }
    renderPriorityDropDown() {
        return (React.createElement(Select, { id: "contact-us-form-priority", value: this.state.priority, onChange: this.handlePriorityLevelChange, options: priorityLevelOptions }));
    }
    renderPriorityMessage() {
        const { priority } = this.state;
        const message = this.matchPriorityMessages(priority);
        return (React.createElement("p", { className: "contact-us-form__priority-message" }, message));
    }
    matchPriorityMessages(priority) {
        switch (priority) {
            case PriorityLevel.Major:
                return PriorityLevelMessages.Major;
            case PriorityLevel.Minor:
                return PriorityLevelMessages.Minor;
            case PriorityLevel.Blocked:
                return PriorityLevelMessages.Blocked;
            default:
                return PriorityLevelMessages.Minor;
        }
    }
    renderAttachmentSection() {
        return (React.createElement("div", { className: "contact-us-form__attachment" },
            React.createElement("div", { className: "contact-us-form__attachment-content" },
                React.createElement("label", { className: "contact-us-form__label" }, "Add File"),
                React.createElement("div", { className: "contact-us-form__file-upload pxl-btn pxl-btn-default" },
                    "Browse",
                    React.createElement("input", { type: "file", className: "contact-us-form__input", onChange: this.handleSaveAttachment })),
                React.createElement("p", { className: "contact-us-form__attachment-warning" }, "Please refrain from attaching sensitive company data to this request, you may upload them instead."),
                this.renderAttachments())));
    }
    renderAttachments() {
        var _a;
        if (!((_a = this.state.attachments) === null || _a === void 0 ? void 0 : _a.length)) {
            return null;
        }
        return (React.createElement("div", { className: "contact-us-form__attachment-list" }, this.state.attachments.map(this.renderEachAttachment)));
    }
    renderEachAttachment(file, index) {
        const onClickHandler = () => {
            this.handleRemoveAttachment(index);
        };
        return (React.createElement("div", { key: index, className: "form-attachment" },
            React.createElement("p", { className: "form-attachment__file-name" }, file.name),
            React.createElement("button", { className: "form-attachment__delete-button", onClick: onClickHandler },
                React.createElement("i", { className: "icon-cancel" }))));
    }
    renderButtons() {
        const buttonText = this.state.isSending ? 'Sending...' : 'Submit';
        return (React.createElement("div", { className: "contact-us-form__footer" },
            React.createElement("a", { className: "contact-us-form__cancel-button", onClick: this.handleClickCancel }, "Cancel"),
            React.createElement("button", { onClick: this.handleClickSubmit, className: "contact-us-form__submit-button pxl-btn pxl-btn-primary", disabled: this.isSendButtonDisabled() }, buttonText)));
    }
    renderErrorMessage() {
        if (!this.state.isfileUploadError && !this.state.isSubmissionError) {
            return null;
        }
        if (this.state.isfileUploadError) {
            return (React.createElement(Alert, { message: this.state.fileUploadErrorMessage, level: "danger", close: true, onClickClose: this.handleErrorBannerClose }));
        }
        return (React.createElement(Alert, { message: "Submission failed. Please try again", level: "danger", close: true, onClickClose: this.handleErrorBannerClose }));
    }
    handleErrorBannerClose() {
        this.setState({ isfileUploadError: false, isSubmissionError: false });
    }
    handleRemoveAttachment(index) {
        const attachments = [...this.state.attachments];
        attachments.splice(index, 1);
        this.setState({ attachments });
    }
    handleClickCancel() {
        this.props.onClose();
    }
    handleClickSubmit() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.setState({ isSending: true });
            const capturedData = {
                productName: this.state.productName,
                priority: this.state.priority,
                description: this.state.description,
                subject: this.state.subject,
                pageSource: this.props.pageSource,
                attachments: this.state.attachments,
                sourceUrl: this.state.sourceUrl
            };
            try {
                this.handleErrorBannerClose();
                const result = yield this.props.onSubmitFn(capturedData);
                if ((_a = result) === null || _a === void 0 ? void 0 : _a.success) {
                    this.props.onSubmissionCallBack(result.ticketId, result.success);
                }
                else {
                    this.setState({ isSending: false, isSubmissionError: true });
                }
            }
            catch (e) {
                this.setState({ isSending: false, isSubmissionError: true });
            }
        });
    }
    handleSaveAttachment(changeEvent) {
        const attachments = [...this.state.attachments];
        if (changeEvent.target.files) {
            const valid = this.validateFile(changeEvent.target.files[0]);
            if (valid) {
                this.clearFileErrorState();
                attachments.push(changeEvent.target.files[0]);
                this.setState({ attachments });
            }
        }
    }
    handleSetSubject(e) {
        var _a, _b;
        if (((_b = (_a = e) === null || _a === void 0 ? void 0 : _a.target) === null || _b === void 0 ? void 0 : _b.value) != null) {
            this.setState({ subject: e.target.value });
        }
    }
    handleSetDescription(_, value) {
        this.setState({ description: value });
    }
    handlePriorityLevelChange(_, value) {
        this.setState({ priority: value });
    }
    isSendButtonDisabled() {
        return !(!this.state.isSending && (!!this.state.subject && !!this.state.description));
    }
    clearFileErrorState() {
        this.setState({
            isfileUploadError: false,
            fileUploadErrorMessage: ''
        });
    }
    validateFileExtension(file) {
        const isValid = !!file
            && supportedtFileExtensions
                .some(fileExtension => file.name.endsWith(fileExtension));
        if (!isValid) {
            this.setState({
                isfileUploadError: true,
                fileUploadErrorMessage: 'Unsupported File Type. Please upload a supported type.'
            });
        }
        return isValid;
    }
    validateFileSize(file) {
        const isValid = !!file && file.size <= this.state.fileSizeLimitInBytes;
        if (!isValid) {
            this.setState({
                isfileUploadError: true,
                fileUploadErrorMessage: 'Size limit exceeded. Please upload a file of size less than 25Mb.'
            });
        }
        return isValid;
    }
    validateFile(file) {
        return !!file && this.validateFileSize(file) && this.validateFileExtension(file);
    }
}
